import { IChildFan } from './IChildFan'
import { IFriend } from './IFriend'
import { IGreenplusData } from './IGreenplusData'
import { IMembershipData } from './IMembershipData'
import { IPersonalDetails } from './IPersonalDetails'
import { ISFShopifyDiscountCode } from './ISFShopifyDiscountCode'

export interface IUser {
  isAuthenticated: boolean
  email?: string
  password?: string
  terms?: boolean
  newsletter?: boolean
  personalDetails?: IPersonalDetails
  token?: string
  registeredCognito?: boolean
  creditAmount?: number | null

  // Extra Data
  memberships?: IMembershipData[]
  greenpluses?: IGreenplusData[]
  children?: IChildFan[]
  friends?: IFriend[]
  coupons?: ISFShopifyDiscountCode[]
}

export enum IUserFrom {
  SIGN_UP = 'SIGN_UP',
  LOGIN = 'LOGIN',
}
